<template>
  <div v-if="amReady">
    <el-row>
      <div class="mb-5 border-bottom" v-if="formHeader">
        <h3>{{ ((!editMode) ? $ml.get('create') : $ml.get('edit')) + ' ' + module.info.caption }}</h3>
      </div>
    </el-row>

    <el-row class="mb-0 pb-0">
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 16 : 16" class="m-0 p-0"
              style="position:absolute;top: -60px; left:0px;">
        <dg-radio-field
            :control="control"
            :defaultValue="defaultDivisionValue"
            :disabled="(defaultDivision)?true :false"
            :field_span="20"
            :label_span="24"
            :options="divisionsList"
            :translateLabel="false"
            :translateLabels="false"
            @amUpdated="divisionUpdated"
            field_mark=""
            label=""
            name="division_id"
            rules="required"
            v-show="allowDivisionChanging"></dg-radio-field>
        <!--<dg-select-field
            :control="control"
            :defaultValue="defaultDivisionValue"
            :disabled="(defaultDivision)?true :false"
            :field_span="20"
            :label_span="24"
            :options="divisionsList"
            :translateLabel="false"
            :translateLabels="false"
            @amUpdated="divisionUpdated"
            field_mark="required"
            label="Division"
            name="division_id"
            rules="required"></dg-select-field>-->
      </el-col>

      <div class="mt-0 mb-0" v-if="dataModel.division_id">
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4"
                v-if="searchByVendorOption && !defaultDestination">
          <dg-select-field
              :control="control"
              :defaultValue="defaultVendorValue"
              :disabled="(defaultVendorValue && !searchByVendorOption )?true :false"
              :field_span="24"
              :label_span="24"
              :options="vendorsDropdownList"
              :translateLabel="false"
              :translateLabels="false"
              @amUpdated="vendorUpdated"
              class="mt-0 mb-0"
              field_mark="required"
              htmlautocomplete="new-password"
              label="Vendor"
              labelProperty="label"
              name="vendor_id"
              placeholder="Vendor"
              rules="required"
              valueProperty="value"
          ></dg-select-field>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
          <dg-select-field
              :control="control"
              :defaultValue="defaultDestinationValue"
              :disabled="(defaultDestination)?true :false"
              :field_span="24"
              :label_span="24"
              :options="destinationsDropDownList"
              :translateLabel="false"
              :translateLabels="false"
              @amUpdated="destinationUpdated"
              class="mt-0 mb-0"
              field_mark="required"
              htmlautocomplete="new-password"
              label="Destination"
              labelProperty="label"
              name="destination_id"
              placeholder="Canada / ATI"
              rules="required"
              valueProperty="value"
          ></dg-select-field>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4" class="mt-0 mb-0"
                v-if="!searchByVendorOption || defaultDestination || true">
          <dg-select-field
              :control="control"
              :defaultValue="defaultRateValue"
              :disabled="(defaultRate)?true :false"
              :field_span="24"
              :label_span="24"
              :options="destinationRateDropDownList"
              :translateLabel="false"
              :translateLabels="false"
              @amUpdated="rateUpdated"
              class="mt-0 mb-0"
              field_mark="required"
              label="Rate"
              name="rate_id"
              rules="required"></dg-select-field>

          <!--<dg-select-field
              :control="control"
              :field_span="19"
              :label_span="24"
              :options="fusionServerList"
              :translateLabels="false"
              field_mark="required"
              label="fusion_server"
              name="pbx_server_url"
              rules="required"></dg-select-field>-->
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 3 : 3" class="mt-0 mb-0">
          <dg-select-field
              :control="control"
              :defaultValue="lastSelectedTestType"
              :field_span="24"
              :label_span="24"
              :options="userTestingPanelSetting"
              :translateLabels="false"
              @amUpdated="testTypeUpdated"
              class="mt-0 mb-0"
              field_mark="required"
              label="test_type"
              name="call_test_type"
              rules="required"></dg-select-field>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 3 : 3" class="mt-0 mb-0">
          <dg-text-field
              :control="control"
              :defaultValue="lastSelectedCallerId"
              :field_span="24"
              :label_span="24"
              :translateLabel="false"
              @amUpdated="callerIdUpdated"
              class="mt-0 mb-0"
              field_mark="required"
              label="Caller ID"
              name="bc_caller_id_number"
              placeholder="001 9421 8273 56"
              rules="required"></dg-text-field>
        </el-col>
        <!--<el-col :class="$langConfig.cssClass" :span="(!editMode)? 3 : 3" class="mt-0 mb-0">
          <dg-label-field label="Rate" :translate="false"></dg-label-field>
          <div class="fake-input-field">
            {{ selectedRateEffectiveDate }}
          </div>
        </el-col>-->
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 3 : 3" class="mt-0 mb-0">
          <dg-label-field :translate="false" label="Created Date"></dg-label-field>
          <div class="fake-input-field">
            {{ selectedRateEffectiveDate }}
          </div>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 3 : 3" class="mt-0 mb-0" v-if="!isUserCustomer">
          <dg-label-field :translate="false" label="Status"></dg-label-field>
          <div class="fake-input-field-no-spaces">
            <div style="position: relative;top: -5px">
              <callTestStatusViewer :callTestStatus="selectedRateStatus" class="fake-input-field"
                                    v-if="selectedRateStatus"></callTestStatusViewer>
            </div>
          </div>
        </el-col>
      </div>
    </el-row>

    <el-row class="mt-2 pt-0 mb-0" v-if="dataModel.division_id">
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 14 : 14" class="mt-0 pt-0">
        <dg-text-field
            :control="control"
            :defaultValue="lastSelectedPhoneNumbers"
            :field_span="22"
            :label_span="24"
            @amUpdated="phoneNumbersUpdated"
            class="mt-0 pt-0"
            field_mark="required"
            field_master_container_style="margin-bottom:0px;"
            label="phone_numbers"
            name="bc_phone_numbers"
            placeholder="00123 456 789, 0012456 7890"
            rows="6"
            rules="required"
            type="textarea">
          <template slot="field_note">
            <sub>phone numbers separated with comma " , "</sub>
          </template>
        </dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 10 : 10" class="pt-2">
        <el-row v-if="selectedRate">
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 5 : 5">
            <dg-select-field
                :control="control"
                :defaultValue="1"
                :field_span="20"
                :label_span="20"
                :options="numbersToGenerateOptions"
                :translateLabel="false"
                :translateLabels="false"
                field_mark=""
                label="Count"
                labelProperty="label"
                name="numbers_to_generate"
                placeholder="Canada / ATI"
                valueProperty="value"
            ></dg-select-field>
          </el-col>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 9 : 9" class="pt-1">
            <el-button @click="generateNumbers" class="d-inline-block mt-4" size="small"
                       style="background-color: #939052"
                       type="info">Generate
              Numbers
            </el-button>
          </el-col>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 7 : 7">
            <dg-text-field
                :control="control"
                :field_span="24"
                :label_span="24"
                :translateLabel="false"
                class="p-0"
                field_mark=""
                inputClass=""
                label="Length"
                name="numbers_to_generate_length"
                placeholder=""
                rules=""
                style="max-width: 100px;"></dg-text-field>
          </el-col>
        </el-row>
        <el-row v-if="selectedRate">
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 5 : 5">
            <dg-select-field
                :control="control"
                :defaultValue="1"
                :field_span="20"
                :label_span="20"
                :options="databaseNumbersToGetOptions"
                :translateLabel="false"
                :translateLabels="false"
                field_mark=""
                label="Count"
                labelProperty="label"
                name="numbers_to_get"
                placeholder=""
                valueProperty="value"
            ></dg-select-field>
          </el-col>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 9 : 9" class="pt-1">
            <el-button @click="getNumbers" class="d-inline-block mt-4" size="small" style="background-color: #939052"
                       type="info">Database Numbers
            </el-button>
          </el-col>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4" class="mt-0 pt-0"
                  v-loading="loadingRequests">
            <dg-button
                v-if="!freeTrialControlTestsDisabled"
                :click="createModule"
                :text="actionButtonLabel"
                :type="actionButtonType"
                class="text-capitalize"
                icon=""
                style="margin-top: 27px; padding: 9px 29px !important;"></dg-button>
            <dg-button
                v-if="freeTrialControlTestsDisabled"
                :click="youHaveReachedYourDailyLimit"
                text="Limit Reached"
                :translate="false"
                :type="actionButtonType"
                class="text-capitalize"
                icon=""
                style="margin-top: 27px; padding: 9px 29px !important;"></dg-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="mt-0 border-bottom">
      <span class="error-field-validate-message" v-if="requestErrorMessage">{{requestErrorMessage}}</span>
    </el-row>

    <div class="mb-4">
      <el-row :key="callkey" class="mt-2 mb-5" v-for="(callData, callkey) in callsStackReversed">
        <dg-text-field
            :control="control"
            :defaultValue="sharedCallDetailsId"
            :field_span="21"
            :label_span="3"
            :translateLabel="false"
            field_mark=""
            label="Shared Link"
            name="shared_call_details_id"
            placeholder=""
            rules=""></dg-text-field>
        <callTestResultsTable :liveDataResults='callsStack[callData]'></callTestResultsTable>
      </el-row>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {mapState, mapActions} from 'vuex'
import {notify} from '@/system-services/notify.js'
import iziToast from 'izitoast'
import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import module from './../index.js'
import panelMixin from '@/app/portals/cpanel/mixins/util'

export default {
  components: {
    callTestStatusViewer: () => import('@/components/call-test-status-viewer/View'),
    callTestResultsTable: () => import('@/components/call-test-results-table/View'),
    /*callTestResults: () => import('./../call-test-results/View'),*/
  },
  mixins: [fieldController, panelMixin],
  props: {
    defaultDivision: {
      default: false,
    },
    allowDivisionChanging: {
      default: false,
    },
    defaultDestination: {
      default: false,
    },
    defaultRate: {
      default: false,
    },
    formHeader: {
      default: false,
    },
    editMode: {
      required: true,
      type: Boolean
    },
    onEditCallback: {
      required: false
    },
    onCreateCallback: {
      required: false
    }
  },
  data() {
    return {
      freeTrialControlTestsDisabled: false,
      requestErrorMessage: false,
      defaultRouteDivision: this.$route.params.division,
      selectedVendor: null,
      broadcastsIdsStack: [],
      callsStack: {},
      callsStackReversed: [],
      defaultVendorValue: null,
      defaultDivisionValue: null,
      defaultDestinationValue: null,
      defaultRateValue: null,
      isUserReseller: $store.getters['user-state/isUserReseller'],
      isUserCustomer: $store.getters['user-state/isUserCustomer'],
      currentDomain: process.env.VUE_APP_CURRENT_DOMAIN,
      isUserMrt: $store.getters['user-state/isUserMrt'],
      broadcastPublicId: null,
      componentIsActive: true,
      liveDataResults: [],
      currentBroadcastId: null,
      broadcast: null,
      selectedRate: null,
      selectedRateStatus: null,
      selectedRateEffectiveDate: null,
      numbersToGenerateOptions: [
        {
          label: '1',
          value: 1
        },
        {
          label: '5',
          value: 5
        },
        {
          label: '10',
          value: 10
        },
        {
          label: '15',
          value: 15
        },
        {
          label: '20',
          value: 20
        },
        {
          label: '100',
          value: 100
        }
      ],
      databaseNumbersToGetOptions: [
        {
          label: '1',
          value: 1
        },
        {
          label: '5',
          value: 5
        },
        {
          label: '10',
          value: 10
        },
        {
          label: '100',
          value: 100
        }
      ],
      divisionsList: [],
      vendorsDropdownList: [],
      destinationsDropDownList: [],
      destinationRateDropDownList: [],
      userTestingPanelSetting: [],
      control: this,
      amReady: false,
      module: {
        ...module
      },
      dataModel: {
        destination_id: null,
        division_id: null,
        number_length: ''
      },
      fusionServerList: [
        /*{
          'label': 'London',
          'value': '142.12.44.90'
        },*/
        {
          'label': 'Singapora',
          'value': 'https://206.189.146.252'
        },
        {
          'label': 'New Singapora',
          'value': 'https://128.199.136.157'
        },
        {
          'label': 'London / Mrttester.com',
          'value': 'https://mrttester.com'
        }
      ]
    }
  },
  beforeDestroy() {
    this.componentIsActive = false
  },
  computed: {
    sharedCallDetailsId: function () {
      return this.currentDomain + '/shared/call-details/' + this.broadcastPublicId + (($store.getters['user-state/isUserMrt'] || $store.getters['user-state/isUserMrtEnterprise']) ? ('-' + Math.floor(Math.random() * 9999999)) : '')
    },
    ...mapState('voip-testing-panel-state', ['searchByVendorOption']),
    ...mapState('ajaxManager', ['loadingRequests']),
    ...mapState('voip-testing-panel-state',
        [
          'lastSelectedDivision',
          'lastSelectedDestination',
          'lastSelectedVendor',
          'lastSelectedRate',
          'lastSelectedTestType',
          'lastSelectedCallerId',
          'lastSelectedPhoneNumbers']),
    actionButtonIcon: function () {
      if (!this.editMode) {
        return 'el-icon-phone';
      } else {
        return 'el-icon-phone-outline'
      }
    },
    actionButtonLabel: function () {
      if (!this.editMode) {
        return 'make_test';
      } else {
        return 're-test'
      }
    },
    actionButtonType: function () {
      if (!this.validData) {
        return 'danger text-white font-weight-bold';
      } else if (this.freeTrialControlTestsDisabled){
        return 'btn btn-secondary text-white font-weight-bold'
      } else {
        return 'btn btn-warning text-dark font-weight-bold'
      }
    }
  },
  beforeMount() {
    this.$store.dispatch('user-api/getUserSettingFusionIP').then(r => {
      $store.state['user-state'].ourVOSIP = r
    })

    if (this.defaultDivision) {
      this.defaultDivisionValue = this.defaultDivision
    } else {
      this.defaultDivisionValue = this.lastSelectedDivision
    }

    if (this.defaultDestination) {
      this.defaultDestinationValue = this.defaultDestination
    } else {
      this.defaultDestinationValue = this.lastSelectedDestination
    }

    if (this.defaultValue) {
      this.defaultVendorValue = this.defaultValue
    } else {
      this.defaultVendorValue = this.lastSelectedVendor
    }

    if (this.defaultRate) {
      this.defaultRateValue = this.defaultRate
    } else {
      //this.defaultRateValue = this.lastSelectedRate
    }

    this.panelMixin_getUserVoipDivision('divisionsList', (result) => {
      let r = result
      for (let d in r) {
        if (r[d].label == this.defaultRouteDivision) {
          this.defaultRouteDivision = r[d].value
          this.panelMixin_getVendorsDropdownByDivision('vendorsDropdownList', {divisionId: this.defaultRouteDivision})
        }
      }
      this.amReady = true
    })

    this.getViewDestinations()
    this.getUserTestingPanelTestTypes().then((r) => {
      this.userTestingPanelSetting = r.data
    })

    $store.watch(function (state) {
          return state['voip-testing-panel-state'].searchByVendorOption;
        },
        (val) => {
          if (val) {
            this.destinationsDropDownList = []
          } else {
            this.selectedVendor = null
            this.getViewDestinations()
          }
        }, {deep: false});
  },
  methods: {
    youHaveReachedYourDailyLimit () {
      iziToast.warning({
        title: "Limit Reached",
        message: 'You are allowed to make only 5 tests per day in the trial version',
        position: 'center',
        close: true,
        timeout: 5000,
        animateInside: false
      });
    },
    getViewDestinations() {
      if (this.isUserCustomer || this.isUserReseller) {
        this.getWorkingDestinationsDropdownlist().then((r) => {
          this.destinationsDropDownList = r
        })
      } else {
        this.panelMixin_getDestinations('destinationsDropDownList')
      }
    },
    showLiveResults(broadcastId, iteration) {
      setTimeout(() => {
        let apiData = {id: broadcastId, live: true}
        if ($store.getters['user-state/isUserMrtEnterprise']) {
          apiData.mrt = true
        }
        this.getBroadcastCdr(apiData).then(response => {
          let cdr = response.data
          this.liveDataResults = JSON.parse(cdr.cdr_json)

          Vue.set(this.callsStack, broadcastId, this.liveDataResults)
          /*this.agGrid.rowData = cdrRecords;
          this.recordsCounter = cdrRecords.length;
          this.amReady = true*/
        })
        if (iteration < 60 && this.componentIsActive && this.currentBroadcastId == broadcastId) {
          iteration += 1
          this.showLiveResults(broadcastId, iteration)
        }
      }, 6000)
    },
    phoneNumbersUpdated(inputField) {
      let value = inputField.field.field_value

      this.testingToolsSetState({
        key: 'lastSelectedPhoneNumbers',
        value: value
      })
    },
    callerIdUpdated(inputField) {
      let value = inputField.field.field_value

      this.testingToolsSetState({
        key: 'lastSelectedCallerId',
        value: value
      })
    },
    testTypeUpdated(inputField) {
      let value = inputField.field.field_value

      this.testingToolsSetState({
        key: 'lastSelectedTestType',
        value: value
      })
    },
    rateUpdated(inputField) {
      let value = inputField.field.field_value

      this.testingToolsSetState({
        key: 'lastSelectedRate',
        value: value
      })

      if (value) {
        this.selectedRate = value
        this.getRatePanelInfo({rateId: value}).then((r) => {
          this.selectedRateStatus = r.data.call_test_status_id
          this.selectedRateEffectiveDate = r.data.effective_date
        })
      }
    },
    getNumbers() {
      this.getNumbersFromDatabase({rate_id: this.selectedRate, limit: this.dataModel.numbers_to_get}).then((r) => {
        this.fields['bc_phone_numbers'].field.field_value = r.data
        this.fields['bc_phone_numbers'].field.validateMessage = ''
        this.fields['bc_phone_numbers'].field.updateValue()
      })
    },
    generateNumbers() {
      this.getGeneratedNumbers({
        rate_id: this.selectedRate,
        limit: this.dataModel.numbers_to_generate,
        number_length: this.dataModel.numbers_to_generate_length,
      }).then((r) => {
        this.fields['bc_phone_numbers'].field.field_value = r.data
        this.fields['bc_phone_numbers'].field.validateMessage = ''
        this.fields['bc_phone_numbers'].field.updateValue()
      })
    },
    vendorUpdated(field) {

      let val = field.field.field_value

      this.selectedVendor = val

      this.testingToolsSetState({
        key: 'lastSelectedVendor',
        value: val
      })

      this.panelMixin_getVendorDestinations({vendorId: val}, (r) => {
        this.destinationsDropDownList = r
        this.defaultRateValue = null
        let rateIn = false

        this.destinationRateDropDownList = []
      })

      this.dataModel.destination_id = null
      this.fields['destination_id'].field.field_value = ''
      this.fields['destination_id'].field.updateValue()
      this.fields['destination_id'].field.validateMessage = ''

      if (this.fields.hasOwnProperty('rate_id')) {
        this.fields['rate_id'].field.field_value = ''
        this.fields['rate_id'].field.updateValue()
        this.fields['rate_id'].field.validateMessage = ''
      }

      this.selectedRateStatus = null
    },
    destinationUpdated(field) {
      let val = field.field.field_value

      if (!val) return

      this.testingToolsSetState({
        key: 'lastSelectedDestination',
        value: val
      })

      this.selectedRate = null

      this.dataModel.destination_id = field.field.field_value
      this.panelMixin_getDestinationRate({
        id: val,
        divisionId: this.dataModel.division_id,
        vendor_id: this.selectedVendor
      }, (r) => {
        this.destinationRateDropDownList = r
        this.defaultRateValue = null
        let rateIn = false

        if (this.lastSelectedRate) {
          for (let r in this.destinationRateDropDownList) {
            if (this.destinationRateDropDownList[r]['value'] == this.lastSelectedRate) {

              rateIn = true
            }
          }
          if (rateIn) {
            this.fields['rate_id'].field.field_value = this.lastSelectedRate
            this.fields['rate_id'].field.validateMessage = ''
            this.fields['rate_id'].field.updateValue()
            this.defaultRateValue = this.lastSelectedRate
          }
        }
      })

      if (this.fields.hasOwnProperty('rate_id')) {
        this.fields['rate_id'].field.field_value = ''
        this.fields['rate_id'].field.updateValue()
        this.fields['rate_id'].field.validateMessage = ''
      }

      this.selectedRateStatus = null
    },
    divisionUpdated(inputField) {
      let selectedDivision = inputField.field.field_value

      this.testingToolsSetState({
        key: 'lastSelectedDivision',
        value: selectedDivision
      })

      this.dataModel.destination_id = null
      if (this.fields.hasOwnProperty('destination_id')) {
        this.fields['destination_id'].field.field_value = ''
        this.fields['destination_id'].field.updateValue()
        this.fields['destination_id'].field.validateMessage = ''
      }

      this.dataModel.rate_id = null
      if (this.fields.hasOwnProperty('rate_id')) {
        this.fields['rate_id'].field.field_value = ''
        this.fields['rate_id'].field.updateValue()
        this.fields['rate_id'].field.validateMessage = ''
      }

      this.selectedRateStatus = null

    },
    ...mapActions('voip-vendor-destination-status-api', {
      getWorkingDestinationsDropdownlist: 'workingDropDownList',
    }),
    ...mapActions('voip-testing-numbers-api', {
      getNumbersFromDatabase: 'getNumbersFromDatabase',
      getGeneratedNumbers: 'getGeneratedNumbers'
    }),
    ...mapActions('voip-testing-panel-state', {testingToolsSetState: 'setState'}),
    ...mapActions('voip-testing-panel-api', {
      getUserTestingPanelTestTypes: 'getUserTestingPanelTestTypes',
      getRatePanelInfo: 'getRatePanelInfo',
      getBroadcastCdr: 'getBroadcastCdr'
    }),
    ...mapActions('voip-destination-api', {
      getDestinationsDropdownlist: 'getDropDownList',
      getDestinationRate: 'getDestinationRate'
    }),
    createModule() {
      this.validateFields().then(result => {
        let context = this;
        let data = {data: this.dataModel};
        if (this.editMode) {
          data.id = this.dataToBind.id;
        }

        if (result) {
          let panelUserTestApi = 'panelUserTest'
          let isUserMRT = $store.getters['user-state/isUserMrt']
          let isUserMRTEnterprise = $store.getters['user-state/isUserMrtEnterprise']
          if (isUserMRT || isUserMRTEnterprise) {
            panelUserTestApi = 'panelUserTestMRT'
          }

          let api = (this.editMode) ? 'update' : panelUserTestApi;
          this.$store.dispatch(this.module.info.name + '-api/' + api, data).then(response => {
            iziToast.success({
              title: this.$ml.get('successfully'),
              message: '',
              position: 'topRight',
              close: false,
              timeout: 1900,
              animateInside: true
            });
          }).catch(error => {
            if (error.response.status == 400) {
              this.requestErrorMessage = error.response.data.errorMessage
              if (error.response.data.errorAction == "LIMIT_REACHED") {
                this.freeTrialControlTestsDisabled = true;
              }
              return
            }
            let message = JSON.parse(error.response.data.message)
            let broadcastId = message.data.id
            this.broadcastPublicId = message.data.public_id
            this.broadcastsIdsStack.unshift(this.broadcastPublicId)
            let status = message.status

            Vue.set(this.callsStack, broadcastId, false)
            this.callsStackReversed.unshift(broadcastId)
            this.currentBroadcastId = broadcastId
            this.showLiveResults(broadcastId, 0)

            let title = 'failed'
            let type = 'error'
            if (broadcastId) {
              title = 'successfully'
              type = 'success'
            }

            notify({
              type: type,
              title: title,
            });

            let dataMessage = false
            if (this.onCreateCallback) {
              if (this.broadcastPublicId) {
                dataMessage = message
              }
              this.onCreateCallback(dataMessage)
            }

            this.setfieldsErrorMessage({
              fieldsErrors: error.response.data
            }, this.arefieldsValid);
          })
        }
      })
    }
  }
}
</script>

<style>
.show-live-results-data {
  font-size: 11px;
}
</style>
